import Request from '../../util/fetch';

export default {
    getArtistContract: data => Request.fetch({
        url: '/api/nmusician/workbench/artistcontract/get',
        data
    }),
};



// WEBPACK FOOTER //
// ./client/component/qiyucontent/backend.js